import { THIRD_PARTY_TRACKING_ENDABLED } from '@m/constants/FeatureFlags';
import { User } from '@m/types/api';

import { dataDogLogOut, dataDogSetUser } from './datadogService';
import { sentryLogout, sentrySetUser } from './sentryService';

export const userAnalytics = {
  setUser: (user: User) => {
    if (THIRD_PARTY_TRACKING_ENDABLED) {
      sentrySetUser(user);
      dataDogSetUser(user);
    }
  },
  unsetUser: () => {
    sentryLogout();
    dataDogLogOut();
  },
};
